import { LoadingSpinner } from "@/components/loading-spinner";
import { Button } from "@/components/ui/button";
import { useUpdateAgency } from "@/hooks/agencies";
import { Agency } from "@/models";
import { StarIcon } from "lucide-react";
import { useState } from "react";

export function Favorite({ agency }: { agency: Agency }) {
  const [loading, setLoading] = useState(false);
  const { mutateAsync } = useUpdateAgency({ hideSuccessToast: true });

  const updateFavorite = async () => {
    try {
      setLoading(true);
      await mutateAsync({ ...agency, favorite: !agency.favorite });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button variant="ghost" onClick={() => updateFavorite()}>
      {loading ? (
        <LoadingSpinner />
      ) : agency.favorite ? (
        <StarIcon className="fill-yellow-500 text-yellow-500" />
      ) : (
        <StarIcon className="text-muted-foreground" />
      )}
    </Button>
  );
}
